module.exports = __webpack_public_path__ + "d6a5e1e2a2f930d4426353138fde1172.svg";